import React, { useState, useEffect, Fragment } from 'react'
import { useDispatch } from 'react-redux'

import {
  updateCity as updateCityGraphQL,
  creatCitySpySettings as creatCitySpySettingsGQL,
  updateCitySpySettings as updateCitySpySettingsGQL,
  updateBaCitySettingsGQL,
} from '../../../../../Module/graphQL'
import { authorization } from '../../../../../Module/Auth/Auth'
import CommonView from '../CommonView'
import {
  getCitySettingsData,
  getUsersWithPersonalDataChangeRequest,
} from './gql'

import useGraphQLFetch from 'Utils/Hooks/useGraphQLFetch'
import { showReduxModal } from '../../../../../Reducers/UI/actions'
import { Box } from '@material-ui/core'
import { PATHS } from '../../../../../Config/Routing/paths'

const ModalBody = ({ usersWithPersonalDataChangeRequest, cityId }) => (
  <Box display="flex" flexDirection="column" flexWrap="wrap" mt={3} mb={3}>
    <div>
      <div>
        BA Document Management cannot be disabled while there are pending
        requests for BAs in this city.
      </div>
      <div>
        Please resolve the pending request for{' '}
        {usersWithPersonalDataChangeRequest.map((item, index) => (
          <Fragment key={item.id}>
            <a
              href={`${PATHS.main.dashboard}${
                PATHS.dashboard.cities
              }/${cityId}${PATHS.cities.ambassadors}/${item.id}`}
              target="_blank"
              style={{
                textDecoration: 'none',
                fontStyle: 'italic',
                fontWeight: 'bold',
                fontSize: '14px',
              }}
              rel="noreferrer"
            >
              {item.firstName} {item.lastName}
            </a>
            {index !== usersWithPersonalDataChangeRequest.length - 1
              ? ', '
              : ''}
          </Fragment>
        ))}{' '}
        before disabling this feature.
      </div>
    </div>
  </Box>
)

export const EditCityView = props => {
  const [isSaving, setIsSaving] = useState(false)
  const [cityData, setCityData] = useState({})

  const response = useGraphQLFetch({
    fetchFn: getCitySettingsData,
    defaultFetchArgs: props.cityId,
    fetchId: 'getCitySettingsData',
  })

  const dispatch = useDispatch()

  useEffect(() => {
    if (response.isLoaded) {
      const cityInfo = response.data.city
      if (cityInfo) {
        setCityData(cityInfo)
      }
    }
  }, [response.isLoaded])

  const updateCity = async data => {
    const response = await updateCityGraphQL(
      authorization.getAPIKey(),
      props.cityId,
      data,
    )

    var result = await response.json()

    if (result['errorMessage']) {
      return alert(result['errorMessage'])
    } else if (result.errors && result.errors[0]) {
      return alert(new Error(result.errors[0].message))
    } else {
      window.location.reload()
    }
  }

  const validateUpdateCityPayload = async ({ oldData, newData }) => {
    if (
      oldData.isBaDocumentManagementEnabled &&
      !newData.isBaDocumentManagementEnabled
    ) {
      const cityId = props.cityId
      const usersWithPersonalDataChangeRequest = await getUsersWithPersonalDataChangeRequest(
        {
          cityId,
        },
      )

      if (usersWithPersonalDataChangeRequest.length) {
        dispatch(
          showReduxModal({
            title: 'Cannot Disable BA Document Management',
            children: (
              <ModalBody
                cityId={cityId}
                usersWithPersonalDataChangeRequest={
                  usersWithPersonalDataChangeRequest
                }
              />
            ),

            confirmLabel: 'Ok',
            hideCancel: true,
            aspect: 'nonScrollable',
          }),
        )
        return false
      }
    }

    return true
  }

  const onUpdateCity = async updateData => {
    setIsSaving(true)

    updateData = {
      ...updateData,
      statusV2: updateData.status,
      location: updateData.cityLocation,
    }
    delete updateData.status
    delete updateData.cityLocation

    try {
      const isValid = await validateUpdateCityPayload({
        oldData: cityData,
        newData: updateData,
      })
      if (isValid) {
        await updateCity(updateData)
      }
    } catch (error) {
      console.error({ error })
    } finally {
      setIsSaving(false)
    }
  }

  const updateCitySpySettings = async updateData => {
    setIsSaving(true)

    updateData = {
      ...updateData,
      cityId: props.cityId,
    }

    const isCreating = !cityData.spySettings || !cityData.spySettings.id

    const updateFunc = isCreating
      ? creatCitySpySettingsGQL
      : updateCitySpySettingsGQL

    let newSpyCitySettings
    try {
      const response = await updateFunc(updateData)
      const result = await response.json()
      if (isCreating) {
        newSpyCitySettings =
          result['data'] && result['data']['createSpyCitySettings']
      } else {
        newSpyCitySettings =
          result['data'] && result['data']['updateSpyCitySettings']
      }

      if (result['errorMessage']) return alert(result['errorMessage'])
      if (result.errors && result.errors[0])
        return alert(new Error(result.errors[0].message))

      if (newSpyCitySettings) {
        setCityData({
          ...cityData,
          spySettings: newSpyCitySettings,
        })
      }
    } catch (e) {
      console.error(e)
    } finally {
      setIsSaving(false)
    }
  }

  const updateBaCitySettings = async updateData => {
    setIsSaving(true)

    try {
      const response = await updateBaCitySettingsGQL({
        ...updateData,
        cityId: props.cityId,
      })
      const result = await response.json()

      const newBaCitySettings =
        result['data'] && result['data']['updateBaCitySettings']

      if (newBaCitySettings) {
        setCityData({
          ...cityData,
          baSettings: newBaCitySettings,
        })
      }
      setIsSaving(false)
    } catch (e) {
      console.error(e)
      setIsSaving(false)
    }
  }

  return response.isLoaded && cityData.name ? (
    <CommonView
      isLoaded={response.isLoaded}
      isSaving={isSaving}
      updateCity={onUpdateCity}
      enableEditCountry={false}
      enableChangeTimezone={false}
      cityData={cityData}
      updateCitySpySettings={updateCitySpySettings}
      isEdit={true}
      updateBaCitySettings={updateBaCitySettings}
    />
  ) : null
}
